import React from 'react';

const ScoreEColor = (props) => (
    <svg viewBox="0 0 59.53 59.53" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient
          id="E_color_svg__a"
          x1={59.34}
          y1={29.76}
          x2={-299.4}
          y2={29.76}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.08} stopColor="#c32127" />
          <stop offset={0.29} stopColor="#f05123" />
          <stop offset={0.5} stopColor="#fed206" />
          <stop offset={0.71} stopColor="#a0cc3a" />
          <stop offset={0.93} stopColor="#33ba9a" />
        </linearGradient>
      </defs>
      <g data-name="Vrstva 2">
        <circle
          cx={29.76}
          cy={29.76}
          r={29.76}
          style={{
            fill: "url(#E_color_svg__a)",
          }}
        />
        <path
          d="M38.11 44H20.43V16.42h17.68v4.8H26.94v6.06h10.39v4.8H26.94v7.13h11.17Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
    </svg>
  );
  
  export default ScoreEColor;